const organization = {
    require_membership: "L'utilisateur doit être membre de l'organisation pour continuer.",
    role_names_not_found: "Des noms de rôles non valides ont été détectés : {{names,list(type:conjunction)}}. Veuillez créer ces rôles d'abord avant de continuer.",
};
export default Object.freeze(organization);
